import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link } from "react-router-dom";
import { AiOutlineRightCircle } from "react-icons/ai";
import { FaLocationDot } from "react-icons/fa6";
import { useLocation } from "react-router-dom";
import { useAMGSelectedContext } from "../../Context/GlobalContext";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: "12px",
    fontWeight: "600",
  },
  secondaryHeading: {
    fontSize: "12px",
    fontFamily: "inherit",
  },
  iconStyle: {
    height: "2em",
    width: "2em",
  },
}));

export default function AccordionUi({
  equipmentGroupList,
  onClick,
  setActiveAccorder,
  activeAccorder,
  plantList,
}) {
  const location = useLocation();
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(activeAccorder);
  const selectedAnlageG = useAMGSelectedContext();
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const [path, setPath] = useState("/equipmentGrpEqiupment");
  const handleClick = (eqlist, event, index) => {
    event.stopPropagation();
    setActiveAccorder(index);
    let tempPlant = eqlist.plantId + "-" + plantList[index];
    onClick(eqlist.id, eqlist.bezeichnung, eqlist.hatEditfunktion, tempPlant);
  };
  useEffect(() => {
    const _path =
      location.pathname === "/inspection"
        ? "/inspection"
        : "/equipmentGrpEqiupment";

    setPath(_path);
  }, [location]);

  return (
    equipmentGroupList && (
      <div className={classes.root + " sidebarAccordion"} id="accordion">
        {plantList &&
          plantList.map((item, index) => (
            <Accordion
              key={index}
              expanded={expanded === index}
              onChange={handleChange(index)}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon className="accordionIcon" />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography className={classes.heading}>
                  <FaLocationDot className="svgIcon mr-3" />{" "}
                  {equipmentGroupList[item]?.[0]?.["plantId"] + "-" + item}
                </Typography>
              </AccordionSummary>
              <ul className="pl-4 pr-2">
                {equipmentGroupList[item]?.map((eqlist, innerIndex) => (
                  <li
                    className={`${
                      selectedAnlageG === eqlist.id ? "active" : ""
                    } pt-1 pb-1 pl-2  cursorPoint pr-2`}
                    key={innerIndex}
                  >
                    <Link
                      className="d-flex flex-row w-100"
                      to={path}
                      onClick={(event) => handleClick(eqlist, event, index)}
                      style={{ textDecoration: "none" }}
                    >
                      <div className="col-11 pl-0 pr-0 equpGrpNameCls">
                        {eqlist.equipmentCountDisplay}
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </Accordion>
          ))}
      </div>
    )
  );
}
